import bigDecimal from "js-big-decimal";
import Web3 from "web3";
const bigUnit = new bigDecimal("1000000000000000000");
const domains = 'https://api3.minicorgi.xyz';
const contractUsdt = "0x55d398326f99059ff775485246999027b3197955";
const abi_usdt = [{ "inputs": [], "payable": false, "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "spender", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "previousOwner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "newOwner", "type": "address" }], "name": "OwnershipTransferred", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "constant": true, "inputs": [], "name": "_decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "_name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "_symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "spender", "type": "address" }], "name": "allowance", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "approve", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "balanceOf", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "burn", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "subtractedValue", "type": "uint256" }], "name": "decreaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "getOwner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "addedValue", "type": "uint256" }], "name": "increaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "mint", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "owner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [], "name": "renounceOwnership", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "totalSupply", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transfer", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "sender", "type": "address" }, { "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transferFrom", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "newOwner", "type": "address" }], "name": "transferOwnership", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }]

const contractDeposit = "0x5Db61d405E12D96E635637474BbCCC3204374823";
const abi_deposit = [{ "inputs": [{ "internalType": "address", "name": "joinToken", "type": "address" }], "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "previousOwner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "newOwner", "type": "address" }], "name": "OwnershipTransferred", "type": "event" }, { "inputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "name": "_historyStakes", "outputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }, { "internalType": "address", "name": "userAddress", "type": "address" }, { "internalType": "uint256", "name": "timestamp", "type": "uint256" }, { "internalType": "string", "name": "id", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "_joinToken", "outputs": [{ "internalType": "contract IERC20Mintable", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "amountss", "type": "uint256" }, { "internalType": "string", "name": "_myString", "type": "string" }], "name": "deposit", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "contract IERC20", "name": "tokens", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "end", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "contract IERC20", "name": "tokens", "type": "address" }], "name": "ended", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "getdAllUsers", "outputs": [{ "components": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }, { "internalType": "address", "name": "userAddress", "type": "address" }, { "internalType": "uint256", "name": "timestamp", "type": "uint256" }, { "internalType": "string", "name": "id", "type": "string" }], "internalType": "struct casino.HistoryStakes[]", "name": "", "type": "tuple[]" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "owner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "renounceOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "totalPackage", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "newOwner", "type": "address" }], "name": "transferOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }]

// user
const deposit = async function (amount) {
    // return
    const web3 = new Web3(Web3.givenProvider);
    const accounts = await web3.eth.getAccounts();
    const contract = new web3.eth.Contract(
        abi_deposit,
        contractDeposit
    );
    if (!accounts.length) {
        return;
    }
    console.log(accounts[0].toLocaleLowerCase(), new bigDecimal(amount * 1).multiply(bigUnit).value);
    // return
    return await contract.methods
        .deposit(new bigDecimal(amount).multiply(bigUnit).value, accounts[0].toLocaleLowerCase())
        .send({ from: accounts[0] })
        .catch((err) => {
            console.log(err);
            return false;
        });
};
const checkApproveStaking = async () => {
    // connect acount
    const web3 = new Web3(Web3.givenProvider);
    const accounts = await web3.eth.getAccounts();
    const contract = new web3.eth.Contract(
        abi_usdt,
        contractUsdt
    );
    if (!accounts.length) {
        return;
    }
    // console.log(contract.methods);
    // return;
    let amountToken, amountApprove;
    let getAmountToken = await contract.methods.balanceOf(accounts[0]).call();
    let getAmountApprove = await contract.methods
        .allowance(accounts[0], contractDeposit)
        .call();
    amountToken = Number(new bigDecimal(getAmountToken).divide(bigUnit).value);
    amountApprove = Number(
        new bigDecimal(getAmountApprove).divide(bigUnit).value
    );
    // console.log(amountToken, amountApprove);
    // console.log(amountToken <= amountApprove);
    if (amountToken <= amountApprove) {
        return { stt: true, balance: amountToken };
    } else {
        return { stt: false, balance: amountToken };
    }
};

const submitApproveStaking = async () => {
    // return
    const web3 = new Web3(Web3.givenProvider);
    const accounts = await web3.eth.getAccounts();
    if (!accounts.length) {
        return;
    }
    const contract = new web3.eth.Contract(
        abi_usdt,
        contractUsdt
    );
    let amountToken;
    let getAmountToken = await contract.methods.balanceOf(accounts[0]).call();

    amountToken = Number(new bigDecimal(getAmountToken).divide(bigUnit).value);
    var dataAmount = new bigDecimal(amountToken).multiply(bigUnit).value;
    console.log(contractDeposit, dataAmount);
    return await contract.methods
        .approve(contractDeposit, dataAmount)
        .send({ from: accounts[0] })
        .catch((err) => {
            console.log(err);
            return false;
        });
};

const getAssessToken = () => {
    return window.localStorage.getItem('access_token');
}

const updateInfoUserss = async () => {
    try {
        const res = await fetch(`${domains}/auth?token=${getAssessToken()}`, {
            method: "GET",
        })

        const data = await res.json();
        // console.log(data.data);

        if (data.data) {
            // if (!data.data.description.unpaid_balance) {
            //     data.data.description.unpaid_balance = 
            // }
            // unpaid_balance
            if (!data.data.description.unpaid_balance) {
                data.data.description.unpaid_balance = [0, 0]
            } else {
                data.data.description.unpaid_balance = JSON.parse(data.data.description.unpaid_balance);
            }
            // unpaid_balanceOld
            if (!data.data.description.unpaid_balanceOld) {
                data.data.description.unpaid_balanceOld = [0, 0]
            } else {
                data.data.description.unpaid_balanceOld = JSON.parse(data.data.description.unpaid_balanceOld);
            }
            // console.log(data.data);
            window.localStorage.setItem('dataUser', JSON.stringify(data.data))
        }
        return res
    } catch (error) {
        console.log(error);
        return
    }
}

const getInfoUserss = async () => {
    try {
        if (window.localStorage.getItem('dataUser')) {
            return JSON.parse(window.localStorage.getItem('dataUser'))
        }
        return false
    } catch (error) {
        console.log(error);
        return false
    }
}

const checkRefUser = async (address) => {
    try {
        const res = await fetch(`${domains}/user/checkRef?address=${address}`, {
            method: "GET",
        })
        return res
    } catch (error) {
        console.log(error);
        return
    }
}

const getHistory = async (type) => {
    try {
        const res = await fetch(`${domains}/user/history?type=${type}&page=${0}&token=${getAssessToken()}`, {
            method: "GET",
        }).then((res) => res.json());
        return res
    } catch (error) {
        console.log(error);
        return
    }
}



//lending
const getInfoLending = async () => {
    try {
        const res = await fetch(`${domains}/lending?token=${getAssessToken()}`, {
            method: "GET",
        }).then((res) => res.json());
        return res
    } catch (error) {
        console.log(error);
        return
    }
}
const lending = async (amount) => {
    try {
        const res = await fetch(`${domains}/lending/lending?amount=${amount}&token=${getAssessToken()}`, {
            method: "GET",
        }).then((res) => res.json());
        return res
    } catch (error) {
        console.log(error);
        return
    }
}
const withdraw = async () => {
    try {
        const res = await fetch(`${domains}/lending/withdraw?token=${getAssessToken()}`, {
            method: "GET",
        }).then((res) => res.json());
        return res
    } catch (error) {
        console.log(error);
        return
    }
}
const claimTotal = async () => {
    try {
        const res = await fetch(`${domains}/lending/claimTotal?token=${getAssessToken()}`, {
            method: "GET",
        }).then((res) => res.json());
        return res
    } catch (error) {
        console.log(error);
        return
    }
}


//lightwallet
const swap = async (amount, type) => {
    try {
        const res = await fetch(`${domains}/lightwallet/swap?amount=${amount}&type=${type}&token=${getAssessToken()}`, {
            method: "GET",
        }).then((res) => res.json());
        return res
    } catch (error) {
        console.log(error);
        return
    }
}

const tranfer = async (amount, address) => {
    try {
        const res = await fetch(`${domains}/lightwallet/tranfer?amount=${amount}&address=${address}&token=${getAssessToken()}`, {
            method: "GET",
        }).then((res) => res.json());
        return res
    } catch (error) {
        console.log(error);
        return
    }
}
const withdrawBalance = async (amount) => {
    try {
        const res = await fetch(`${domains}/lightwallet/withdraw?amount=${amount}&token=${getAssessToken()}`, {
            method: "GET",
        }).then((res) => res.json());
        return res
    } catch (error) {
        console.log(error);
        return
    }
}

//marketing
const marketing = async (amount) => {
    try {
        const res = await fetch(`${domains}/marketing/marketing?amount=${amount}&token=${getAssessToken()}`, {
            method: "GET",
        }).then((res) => res.json());
        return res
    } catch (error) {
        console.log(error);
        return
    }
}
const withdrawMarketing = async () => {
    try {
        const res = await fetch(`${domains}/marketing/claimTotal?token=${getAssessToken()}`, {
            method: "GET",
        }).then((res) => res.json());
        return res
    } catch (error) {
        console.log(error);
        return
    }
}

const getInfoBet = async () => {

    const token = getAssessToken();


    // alert(amount)
    try {
        const res = await fetch(`${domains}/bet/info`, {
            method: "GET",
        }).then((res) => res.json());

        return res;
    } catch (err) {
        return false;
    }
};

const ShowBlance = (user, type) => {
    if (!user) {
        return 0
    }
    if (type == 1) {
        return user.balancePoint - user.withdrawdPoint
    }
    else {

        return user.balanceUsdt - user.withdrawdUsdt
    }

}
const getChartData = async (amount) => {

    const token = getAssessToken();


    // alert(amount)
    try {
        const res = await fetch(`${domains}/chart/get-chart-data?token=${token}`, {
            method: "GET",
        }).then((res) => res.json());

        return res;
    } catch (err) {
        return false;
    }
};

const bet = async (amount, type) => {

    const token = getAssessToken();


    // alert(amount)
    try {
        console.log(`${domains}/bet/bet?amount=${amount}&type=${type}&token=${token}`);

        const res = await fetch(`${domains}/bet/bet?amount=${amount}&type=${type}&token=${token}`, {
            method: "GET",
        }).then((res) => res.json());

        return res;
    } catch (err) {
        console.log(err);

        return false;
    }
};

const history = async (type, page) => {

    const token = getAssessToken();


    // alert(amount)
    try {
        const res = await fetch(`${domains}/user/history?type=${type}&page=${page}&token=${token}`, {
            method: "GET",
        }).then((res) => res.json());

        return res;
    } catch (err) {
        return false;
    }
};
const get_tree = async () => {
    const token = getAssessToken();
    try {
        const res = await fetch(`${domains}/user/get-tree?token=${token}`, {
            method: "GET",
        }).then((res) => res.json());
        return res;
    } catch (err) {
        console.log(err);
        
        return false;
    }
};

export {
    get_tree,
    bet, getChartData, ShowBlance, getInfoBet, history,
    updateInfoUserss, getInfoUserss, checkRefUser, domains,
    checkApproveStaking,
    submitApproveStaking,
    deposit, getHistory,
    getInfoLending, lending, withdraw, claimTotal,
    withdrawBalance, tranfer, swap,
    marketing, withdrawMarketing
}